import React from 'react';
import './LegalPage.css';
import { useTranslation } from '../hooks/useTranslation';

const TermsOfUsePage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="page-container-narrow">
      <h1 className="page-title">{t('terms.title')}</h1>
      
      <div className="legal-content">
        <p className="legal-intro">
          {t('terms.lastUpdated')} {new Date().toLocaleDateString()}
        </p>

        <section className="legal-section">
          <h2>{t('terms.section1Title')}</h2>
          <p>
            {t('terms.section1Content')}
          </p>
        </section>

        <section className="legal-section">
          <h2>{t('terms.section2Title')}</h2>
          <p>
            {t('terms.section2Content')}
          </p>
          <ul>
            <li>{t('terms.section2Item1')}</li>
            <li>{t('terms.section2Item2')}</li>
            <li>{t('terms.section2Item3')}</li>
            <li>{t('terms.section2Item4')}</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>{t('terms.section3Title')}</h2>
          <p>
            {t('terms.section3Content')}
          </p>
        </section>

        <section className="legal-section">
          <h2>{t('terms.section4Title')}</h2>
          <p>
            {t('terms.section4Content')}
          </p>
        </section>

        <section className="legal-section">
          <h2>{t('terms.section5Title')}</h2>
          <p>
            {t('terms.section5Content')}
          </p>
        </section>

        <section className="legal-section">
          <h2>{t('terms.section6Title')}</h2>
          <p>
            {t('terms.section6Content')}
          </p>
        </section>

        <section className="legal-section">
          <h2>{t('terms.section7Title')}</h2>
          <p>
            {t('terms.section7Content')}
          </p>
        </section>

        <section className="legal-section">
          <h2>{t('terms.section8Title')}</h2>
          <p>
            {t('terms.section8Content')}
          </p>
        </section>
      </div>
    </div>
  );
};

export default TermsOfUsePage;
